import React from 'react';

const SquareProgressBadge = ({ progress, total, text }) => {
  let percent = (progress / total) * 100;

  return (
    <div className="square-progress-badge">
      <div className="square-progress-badge__progress">{progress}</div>
      <div className="square-progress-badge__bar">
        <div className="square-progress-badge__bar-fill" style={{ width: `${percent}%` }}></div>
        <div className="square-progress-badge__bar-bg"></div>
      </div>

      <div className="square-progress-badge__title">{text}</div>
    </div>
  );
};

export default SquareProgressBadge;
